'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  startNavigationLoading,
  subscribeNavigationLoading,
} from '@/lib/navigation-loading';

/** Call before router.push / replace so the dashboard shows loading feedback. */
export function useNavigateWithLoading() {
  const router = useRouter();

  return {
    push: (href: string) => {
      startNavigationLoading();
      router.push(href);
    },
    replace: (href: string) => {
      startNavigationLoading();
      router.replace(href);
    },
  };
}

export function useNavigationLoadingActive(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => subscribeNavigationLoading(setActive), []);

  return active;
}
